// Match-Ups vocabulary shared by API and web. Roster roles are what someone
// does in the field operation; they are not access levels (those are Entra
// app roles in permissions.js).
export const ROSTER_ROLES = Object.freeze([
  { value: 'installer', label: 'Installer' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'job_controller', label: 'Job Controller' },
  { value: 'operations', label: 'Operations' },
]);

export const ROSTER_ROLE_LABEL = Object.freeze(Object.fromEntries(ROSTER_ROLES.map((r) => [r.value, r.label])));

// Installers per team. Two vans, one engineer each.
export const TEAM_SIZE = 2;
